import React, { useState } from "react";
import images from "../../../images.config";
import icons from "../../../icons.config";

const CustomSizeModal = ({onClose}) => {
  const [unit, setUnit] = useState("inches");
  const [measurements, setMeasurements] = useState({});
  const [image, setImage] = useState(images.collection1);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setMeasurements({ ...measurements, [name]: value });
    // Update the image dynamically based on input (dummy logic for demonstration)
    setImage(value ? `image-${value}.jpg` : "default-image.jpg");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Measurements submitted: ", measurements);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 top-16 lg:top-24">
    <div className="bg-tertiary rounded-lg w-full max-w-lg md:max-w-2xl lg:max-w-[60%] h-full md:h-auto lg:h-fit px-6 lg:px-0 py-8 overflow-y-auto">
    
  
      {/* Heading */}
      <h2 className="text-center text-primary1 text-xl md:text-2xl lg:text-3xl font-outfit font-normal mb-4">
        CUSTOM SIZE
      </h2>
        {/* Close Button */}
        <button
        onClick={onClose}
        className="relative left-[94%] text-gray-500 hover:text-gray-700 -mt-6 bottom-8"
        aria-label="Close modal"
      >
        <img src={icons.close} alt="close icon" />
      </button>
      <hr className="border-secondary mb-4" />
  
      {/* Content Sections */}
      <div className="flex flex-col md:flex-row ">
        {/* Left Section */}
        <div className="w-full lg:w-1/2 flex justify-center items-center mb-4 md:mb-0 px-2 ">
          <img
            src={image}
            alt="Dynamic Display"
            className="w-full max-w-[200px] md:max-w-[70%]"
          />
        </div>
  
        {/* Right Section */}
        <div className="lg:w-1/2  lg:pr-11 space-y-5">
          <h3 className="text-lg md:text-2xl text-primary1 font-outfit font-light mb-2">
            Choose your units:
          </h3>
          <div className="flex space-x-4 mb-4">
            <label className="flex items-center text-primary1 font-poppins font-light text-sm md:text-base">
              <input
                 type="checkbox"
                name="unit"
                value="inches"
                checked={unit === "inches"}
                onChange={() => setUnit("inches")}
                className="mr-2"
              />
              Inches
            </label>
            <label className="flex items-center text-primary1 font-poppins font-light text-sm md:text-base">
              <input
               type="checkbox"
                name="unit"
                value="cm"
                checked={unit === "cm"}
                onChange={() => setUnit("cm")}
                className="mr-2"
              />
              cm
            </label>
          </div>
  
          <form onSubmit={handleSubmit} className="space-y-8">
            <div className="grid grid-cols-2 gap-4 mb-4">
              {[
                { label: "Chest Measurement", placeholder: "Enter chest size" },
                { label: "High Waist Measurement", placeholder: "Enter waist size" },
                { label: "Mid Waist Measurement", placeholder: "Enter hip size" },
                { label: "Hip Measurement", placeholder: "Enter shoulder size" },
                { label: "Maxi Length Measurement", placeholder: "Enter sleeve length" },
                { label: "Mini Length Measurement", placeholder: "Enter overall length" },
              ].map((field, index) => (
                <div key={index} className="flex flex-col">
                  <label className="mb-1 text-primary1 font-outfit font-light text-sm md:text-base">
                    {field.label}
                  </label>
                  <input
                    type="text"
                    name={field.label.toLowerCase()}
                    placeholder={field.placeholder}
                    className="p-2 border text-primary1 placeholder:text-secondary text-sm"
                    onChange={handleInputChange}
                  />
                </div>
              ))}
            </div>
  
            <label className="flex items-center mb-4 text-primary1 font-outfit font-normal text-sm md:text-base">
              <input type="checkbox" className="mr-2" /> Save measurements for next time
            </label>
  
            <div className="mt-3">
            <button
              type="submit"
              className="w-full bg-hcolor text-primary2 py-2 hover:bg-tertiary hover:text-hcolor border-2 border-hcolor transition font-medium font-outfit"
            >
              SUBMIT
            </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  
  );
};

export default CustomSizeModal;
